import { GravaterActions } from './actions';
import { GravatarMap, GravatarTypes } from './types';
export const gravatars = (state: GravatarMap = {}, action: GravaterActions) => {
  switch (action.type) {
    case GravatarTypes.GravatarsSuccess:
      return { ...state, ...action.data.EmailToLink };
  }
  return state;
};
